import { useAppStore } from '../stores/appStore';

export const translations = {
  en: {
    // Search
    searchPlaceholder: 'Say the API #, Well Name, or Facility Type',
    searchPlaceholderHint: 'e.g. "compressor" or "flare"',
    searchResults: 'Search Results',
    noResults: 'No results found',
    byFacilityType: 'By Facility Type',
    noFilteredResults: 'No results match your filters. Try adjusting or clearing filters.',
    tryDifferentSearch: 'Try a different search term or check your filters',
    letters: 'Letters',
    secondLetters: 'Second Letter',
    thirdLetters: 'Third Letter',
    fourthLetters: 'Fourth Letter',
    loadingResults: 'Loading results...',
    noTypeFound: 'No {0} found',
    showingCountOf: 'Showing {0} of {1} results',
    searchingFor: 'Searching for',
    results: 'results',
    result: 'result',
    cachedLabel: 'cached',
    liveLabel: 'live',
    
    // Navigation
    navigate: 'Navigate',
    getDirections: 'Get Directions',
    startNavigation: 'Start Navigation',
    
    // Favorites
    favorites: 'Favorites',
    noFavorites: 'No saved facilities yet',
    tapToSave: 'Tap the star icon on any facility to save it',
    savedFacilities: 'saved facilities',
    savedFacility: 'saved facility',
    removeFromFavorites: 'Remove from favorites',
    addToFavorites: 'Add to favorites',
    
    // Facility types
    all: 'All',
    well: 'Well',
    rig: 'Rig',
    swd: 'SWD',
    facility: 'Facility',
    wells: 'Wells',
    rigs: 'Rigs',
    swds: 'SWDs',
    tankBattery: 'Tank Battery',
    flareStack: 'Flare Stack',
    compressor: 'Compressor',
    gasPlant: 'Gas Plant',
    brineWell: 'Brine Well',
    refinery: 'Refinery',
    treatingPlant: 'Treating Plant',
    wellHead: 'Well Head',
    gasGathering: 'Gas Gathering',
    injectionPlant: 'Injection Plant',
    gasPipeline: 'Gas Pipeline',
    crudePipeline: 'Crude Pipeline',
    waterPipeline: 'Water Pipeline',
    gasStorage: 'Gas Storage',
    belowGradeTank: 'Below Grade Tank',
    meteringStation: 'Metering Station',
    crudePump: 'Crude Pump',
    pits: 'Pits',
    wasteMgmt: 'Waste Mgmt',
    recycling: 'Recycling',
    remediate: 'Remediate',
    abatement: 'Abatement',
    serviceCo: 'Service Co.',
    classIII: 'Class I/II',
    portaPotty: 'Porta Potty',
    wellPad: 'Well Pad',
    location: 'Location',
    activeOps: 'Active Ops',
    more: 'More...',
    tacoTruck: 'Taco Truck',
    tacoTruckName: 'Truck Name',
    enterTruckName: 'Enter taco truck name',
    tacoTruckMarked: 'Taco truck location marked',
    tacoNameExists: 'A taco truck with this name already exists today',
    showTacoLocations: 'Show taco truck locations',
    searchFacilityTypes: 'Search Across 33 Facility Types',
    treating: 'Treating',
    injection: 'Injection',
    gasLine: 'Gas Line',
    crudeLine: 'Crude Line',
    waterLine: 'Water Line',
    gasGather: 'Gas Gather',
    metering: 'Metering',
    belowGrade: 'Below Grade',
    
    // Actions
    copy: 'Copy',
    copied: 'Copied!',
    apiCopied: 'API {0} copied!',
    delete: 'Delete',
    cancel: 'Cancel',
    confirm: 'Confirm',
    close: 'Close',
    save: 'Save',
    share: 'Share',
    saveSettings: 'Save Settings',
    submit: 'Submit',
    add: 'Add',
    remove: 'Remove',
    edit: 'Edit',
    
    // Status
    loading: 'Loading...',
    offline: 'Offline',
    online: 'Online',
    active: 'Active',
    inactive: 'Inactive',
    error: 'Error',
    success: 'Success',
    
    // FAB tooltips
    addFacility: 'Add New Facility',
    activeOperations: 'Active Operations',
    toggleTheme: 'Toggle Theme',
    toggleLanguage: 'Cambiar a Español',
    viewOnMap: 'View on Map',
    lightMode: 'Light Mode',
    darkMode: 'Dark Mode',
    highContrast: 'High Contrast',
    normalContrast: 'Normal Contrast',
    
    // Map
    mapView: 'Map View',
    listView: 'List View',
    satellite: 'Satellite',
    terrain: 'Terrain',
    
    // Filters
    allCounties: 'All Counties',
    filterByCounty: 'Filter by County',
    filterByType: 'Filter by Type',
    filterByOperator: 'Filter by Operator',
    filterByStatus: 'Filter by Status',
    allStatus: 'All Status',
    allTypes: 'All Types',
    allOperators: 'All Operators',
    sortAZ: 'Sort A-Z',
    sortZA: 'Sort Z-A',
    clearFilters: 'Clear Filters',
    filter: 'filter',
    filters: 'filters',
    
    // Voice
    tapToSpeak: 'Tap to speak',
    searchHint: 'Say the API #, Well Name, or Facility Type',
    searchHintFallback: 'e.g. "compressor" or "flare"',
    listening: 'Listening...',
    voiceNavigation: 'Voice Navigation',
    speakDestination: 'Speak your destination',
    recentSearches: 'Recent Searches:',
    searchBelow: 'Type to Search',
    voiceNotSupported: 'Voice unavailable',
    
    // Facility details
    apiNumber: 'API Number',
    operator: 'Operator',
    county: 'County',
    status: 'Status',
    distance: 'Distance',
    miles: 'miles',
    feet: 'feet',
    coordinates: 'Coordinates',
    lat: 'LAT',
    lng: 'LNG',
    latitude: 'Latitude',
    longitude: 'Longitude',
    wellName: 'Well Name',
    wellType: 'Well Type',
    pool: 'Pool',
    district: 'District',
    township: 'Township',
    range: 'Range',
    section: 'Section',
    
    // Directions
    turnLeft: 'Turn left',
    turnRight: 'Turn right',
    continueOn: 'Continue on',
    arrive: 'Arrive at destination',
    inMiles: 'in {0} miles',
    inFeet: 'in {0} feet',
    
    // Onboarding
    welcome: 'Welcome',
    getStarted: 'Get Started',
    skip: 'Skip',
    next: 'Next',
    back: 'Back',
    
    // Errors
    locationError: 'Unable to get your location',
    networkError: 'Network error. Please try again.',
    searchError: 'Search failed. Please try again.',
    
    // Time
    lastUpdated: 'Last updated',
    justNow: 'Just now',
    minutesAgo: '{0} minutes ago',
    hoursAgo: '{0} hours ago',
    
    // Crews
    myCrews: 'My Crews',
    addCrew: 'Add Crew',
    crewName: 'Crew Name',
    crewMembers: 'Crew Members',
    
    // Landing Page - Hero Section
    heroTagline: 'Half the Price. Twice the Features.',
    heroSubtagline: 'Community-Powered Oilfield Navigation',
    heroDescription: '$10/month • 424,243 wells across NM & TX • Google Maps navigation + caliche routes = routes that get you in and out of any well in the oilfield',
    alreadyUsingZia: 'Already using Zia?',
    openBot: 'Open @ziawellnavbot',
    advancedFeaturesTitle: 'Advanced Features',
    advancedFeaturesDesc: 'Built by oilfield workers, for oilfield workers. Powerful tools for the modern oilfield.',
    
    // Landing Page - Feature Cards
    comingSoon: 'Coming Soon',
    premium: 'Premium',
    exclusive: 'Exclusive',
    voiceNavigationTitle: 'Voice Navigation',
    voiceNavigationDesc: 'Hands-free search with Telegram Premium transcription',
    voiceNavigationSubtext: 'Speak to search, Telegram handles the transcription',
    telegramChannelsTitle: 'Telegram Channels',
    telegramChannelsDesc: 'Private channels, secure messaging & video streaming',
    telegramChannelsSubtext: 'All integrated into Telegram',
    facilityTypesTitle: '32 Facility Types',
    facilityTypesDesc: 'Wells, tanks, compressors, pipelines, SWDs & more',
    facilityTypesSubtext: 'Most well navigators only cover basic wells',
    dragDropLandmarksTitle: 'Drag & Drop Landmarks',
    dragDropLandmarksDesc: 'Drop pins on cattle guards, windmills, and turns. Chart routes through unmarked territory and find your way out when you\'re deep in unfamiliar country.',
    amigosTitle: 'Amigos',
    amigosDesc: 'Coming Soon - Share your location with friends and see each other in real-time on the map.',
    offlineMapsTitle: 'Offline Maps',
    offlineMapsDesc: 'Download entire basins for offline access. No cell signal? No problem.',
    weatherAlertsTitle: 'Weather & Hazards',
    weatherAlertsDesc: 'Real-time weather data and road hazard warnings to keep you safe.',
    crewTrackingTitle: 'Crew Tracking',
    crewTrackingDesc: 'See your crew locations in real-time. Coordinate better, work safer.',
    basinCommunitiesTitle: 'Basin Communities',
    basinCommunitiesDesc: 'Connect with operators in your basin. Share intel, find crews, post jobs.',
    oilfieldMappingTitle: 'Oilfield Mapping',
    oilfieldMappingDesc: '424,243 wells now in the database. 284,883 TX wells (36 Permian Basin counties) + 139,360 NM wells (32 counties). Find construction locations before they\'re on any official map.',
    oilfieldMappingSubtext: 'See where the rig is moving before it gets there.',
    calicheRoutesTitle: 'Caliche Routes',
    calicheRoutesDesc: 'Navigate roads Google doesn\'t know. Plot routes through unmarked oilfield roads, mark landmarks, and share with your crew.',
    calicheRoutesSubtext: 'Never get lost heading back to the house—even in unfamiliar territory.',
    wellsNearYouTitle: 'Wells Near You',
    wellsNearYouDesc: 'Instantly find the closest wells, rigs, and facilities based on your GPS location.',
    heavyHaulDirectoryTitle: 'Heavy Haul Directory',
    heavyHaulDirectoryDesc: 'Find heavy haul operators, truck services, and equipment rentals in your area.',
    jobsBoardTitle: 'Jobs Board',
    jobsBoardDesc: 'Post jobs, find work, bid on contracts. Connect directly with operators and contractors.',
    hazardsAlertsTitle: 'Hazards & Police Alerts',
    hazardsAlertsDesc: 'Community safety alerts. Report road hazards, cops, and incidents. Stay safe out there.',
    aiAssistantTitle: 'AI Copilot (Grok)',
    aiAssistantDesc: 'Your personal AI that builds a memory of your routes, frequent stops, and work patterns. The more you drive, the smarter it gets.',
    aiAssistantSubtext: '🧠 Learns your daily grind—constantly improving',
    privacyFirstTitle: 'Privacy-First Design',
    privacyFirstDesc: 'No account needed. API keys hidden server-side. Your location never stored. Anonymous hazard reports.',
    privacyFirstSubtext: 'E2E encryption via Telegram • No tracking • No ads 🔒',
    weatherDataTitle: 'Weather Data',
    weatherDataDesc: 'Powered by Google + Open-Meteo (Swiss open-source). Rain, UV, wind, temperature with automatic failover.',
    weatherDataSubtext: 'Flash flood alerts for arroyo safety 🌊',
    englishSpanishTitle: 'English & Spanish',
    englishSpanishDesc: 'Full app support in both languages. Serving the diverse oilfield workforce.',
    englishSpanishSubtext: 'More languages on the way',
    crewsTimesheetsTitle: 'Crews & Timesheets',
    crewsTimesheetsDesc: 'QR code invites, live GPS tracking, meeting points with check-ins, and weekly timesheets auto-sent to your lead.',
    crewsTimesheetsSubtext: 'BYOD-friendly • Privacy-first location sharing',
    quadNavigationTitle: 'Google Maps Navigation',
    quadNavigationDesc: 'Full waypoint support for caliche routes. Navigate through unmapped dirt roads with GPS coordinates.',
    quadNavigationSubtext: 'The only app with multi-waypoint support',
    googleApisTitle: 'Google APIs',
    googleApisDesc: '7 Google APIs integrated now—places, directions, elevation & more. 30+ APIs coming soon.',
    googleApisSubtext: 'Constantly expanding capabilities',
    semiHazmatTitle: 'Semi & Hazmat Routing',
    semiHazmatDesc: 'Routing optimized for semis and hazmat loads. Avoids low bridges, weight limits & restricted roads.',
    semiHazmatSubtext: 'Built for professional drivers',
    cyberThemeTitle: 'Cyber Theme',
    cyberThemeDesc: 'Sleek dark mode with glowing neon accents for night shifts. High contrast mode for bright daylight conditions.',
    cyberThemeSubtext: 'Easy on the eyes, 24/7',
    materialDesignTitle: 'Material Design 3',
    materialDesignDesc: 'Built on Google\'s latest Material Design 3 philosophy. Premium UI with dynamic colors, elevation, and motion.',
    materialDesignSubtext: 'Same design language as Google apps',
    cloudflareTitle: 'Cloudflare Protected',
    cloudflareDesc: 'Enterprise-grade security with global edge network. DDoS protection, SSL, and blazing fast load times from 300+ data centers.',
    cloudflareSubtext: 'D1 database + Workers = instant responses ⚡',
    realTimeDataTitle: 'Real-Time Data',
    realTimeDataDesc: 'Always up-to-date facility information pulled from live data sources',
    realTimeDataSubtext: 'Your data stays current and accurate',
    offlineTitle: 'Download for Offline',
    offlineDesc: 'Access maps and data in the desert, mountains, or anywhere without signal. Maps auto-download to your device—no action required.',
    offlineSubtext: 'Download all 424,243 wells for offline search—284,883 TX + 139,360 NM.',
    basinSafetyTitle: 'Basin Safety Channels',
    basinSafetyDesc: 'Receive real-time alerts for wrecks, traffic, and field incidents in your basin',
    basinSafetySubtext: 'Permian, Delaware, San Juan & Raton',
    readyToStartTitle: 'Ready to Get Started?',
    readyToStartDesc: 'Log in with Telegram to access real-time facility data, voice navigation, and basin safety channels. All communication happens on Telegram with end-to-end encryption.',
    freeTrialHeading: '🎁 7-Day Free Trial • No Credit Card Required',
    forFieldProfessionals: 'For Field Professionals',
    individualPrice: '$10',
    individualSubheading: 'Full access to voice navigation & basin safety alerts',
    individualFeature1: '✓ Voice Navigation',
    individualFeature2: '✓ 424,243 Wells (NM + TX)',
    individualFeature3: '✓ Google Maps with Waypoints',
    individualFeature4: '✓ Offline Maps & Data',
    individualFeature5: '✓ Road Hazard Alerts',
    individualFeature6: '✓ Caliche Routes & Landmarks',
    individualFeature7: '✓ Semi & Hazmat Routing',
    individualFeature8: '✓ Weather Data',
    individualFeature9: '✓ English & Spanish',
    excludedFeature1: '✗ Private Company Channels',
    excludedFeature2: '✗ Crews & Timesheets',
    excludedFeature3: '✗ Team Location Sharing',
    businessPlansHeading: 'Business Plans',
    starterLabel: 'STARTER',
    starterPrice: '$7',
    perUserMonth: '/user/mo',
    starterRange: '5-25 users',
    teamLabel: 'TEAM',
    teamPrice: '$6',
    teamRange: '26-100 users',
    fleetLabel: 'FLEET',
    fleetPrice: '$5',
    fleetRange: '101-250 users',
    enterpriseLabel: 'ENTERPRISE',
    enterprisePrice: '$4',
    enterpriseRange: '251+ users',
    founding50Heading: '🏆 Founding 50 Program',
    founding50Desc: 'Be one of the first 50 service companies to join',
    founding50Price: '$4/user/mo forever',
    founding50Spots: 'spots remaining',
    founding50Locked: 'Rate locked forever, regardless of team size',
    allBusinessPlansInclude: 'All Business Plans Include:',
    businessFeature1: '✓ Everything in Individual',
    businessFeature2: '✓ Private Company Channels',
    businessFeature3: '✓ Crews & Timesheets 🔜',
    businessFeature4: '✓ Amigos - Team Location 🔜',
    businessFeature5: '✓ Dedicated Support Channel',
    businessFeature6: '✓ Custom Facility Integration',
    businessFeature7: '✓ Volume Discounts (100+ users)',
    comparisonHeading: 'Individual vs Business',
    individualPlanTitle: 'Individual — $10/mo',
    businessPlanTitle: 'Business — $4-7/user/mo',
    privacyFirstHeading: '🔒 Your Privacy First:',
    privacyFirstText: 'No account required—Telegram handles authentication. All API keys (Google, OpenWeather) are server-side only; you never see or transmit them. Your location is processed client-side and never stored on our servers. Hazard reporter identity is always anonymous—only basin-level alerts, no exact coordinates. E2E encrypted via Telegram. Auto-delete after 24 hours. No tracking, no ads, no data sales.',
    pricingDisclaimer: '💡 All plans include 7-day free trial • Cancel anytime • Referral rewards available',
    loginTermsText: 'By logging in, you agree to Telegram\'s',
    termsOfService: 'Terms of Service',
    and: 'and',
    privacyPolicy: 'Privacy Policy',
    madeWithLove: 'Made with ❤️ by',
    ziatechsLink: 'Zia Techs',
    charityText: 'We donate 20% of the profit to',
    packsForHunger: 'Packs for Hunger',
    copyright: '© 2026 Zia Well Nav',
    
    // Community Impact Section
    communityImpactTitle: 'Community Impact',
    communityImpactDesc: 'Every subscription directly supports children in our oilfield communities',
    monthlyDonation: 'of monthly subscriptions',
    annualDonation: 'of annual subscriptions',
    packsForHungerDesc: 'Packs for Hunger provides weekend food bags to children facing food insecurity in Lea County schools. Each bag contains nutritious meals to ensure no child goes hungry when school meals aren\'t available.',
    quarterlyImpact: '📊 We publish quarterly impact reports showing exactly how your subscription helps feed local kids.',
    
    
    // FAB labels (more comprehensive)
    search: 'Search',
    aiAssistant: 'AI Assistant',
    favoritesTooltip: 'Favorites',
    mapSettings: 'Map Settings',
    calicheRoutesTooltip: 'Caliche Routes',
    activity: 'Activity',
    jobs: 'Jobs',
    suggestions: 'Suggestions',
    timer: 'Timer',
    networkStatus: 'Network Status',
    qrShare: 'QR Share',
    voice: 'Voice',
    services: 'Services',
    basinCommunity: 'Basin Community',
    crews: 'Crews',
    friends: 'Friends',
    
    // Common UI elements
    openWellNavigator: 'Open Well Navigator',
    subscription: 'Subscription',
    subscriptionInfo: 'Subscription Info',
    individual: 'Individual',
    business: 'Business',
    perMonth: '/month',
    perYear: '/year',
    savePercent: 'Save {0}%',
    choosePlan: 'Choose Plan',
    features: 'Features',
    
    // Messages & Toasts
    homeSaved: 'Home location saved!',
    navigatingHome: 'Navigating home...',
    locationCaptured: 'Location captured! Add a name and save.',
    geolocationNotSupported: 'Geolocation is not supported by your browser',
    failedToSave: 'Failed to save',
    routeDeleted: 'Route deleted',
    routeSaved: 'Route saved',
    photoUploaded: 'Photo uploaded',
    addFavoritesFirst: 'Add some favorites first to see them on the map!',
    
    // Directions & Navigation
    findingNearestWell: 'Finding nearest well...',
    couldNotSearch: 'Could not search for "{0}". {1}',
    noCachedResults: 'No cached results available.',
    pleaseTryAgain: 'Please try again.',
    
    // Cache & Data
    cacheVerified: 'Cache Verified: All cached data is valid',
    noCachedData: 'No cached data to verify. Download some basins first.',
    failedToVerify: 'Failed to verify cache integrity',
    cacheImported: 'Cache Imported: Team cache has been merged successfully',
    failedToImport: 'Failed to import cache',
    historyCleared: 'History Cleared: Search history has been removed',
    failedToClear: 'Failed to clear search history',
    cacheCleared: 'Cache Cleared: All cached data has been removed',
    failedToClearCache: 'Failed to clear cache',
    dataUpdated: 'Data Updated: Facility data was updated overnight',
    
    // Voice Navigation specific
    voiceSearchNotSupported: 'Voice search is not supported on Android Telegram. Please use the search bar to type your search, or tap the facility type buttons below!',
    speakToSearch: 'Speak to search',
    typeToSearch: 'Type to search',
    voiceNotSupportedDevice: 'Voice recognition not supported on this device. Try typing your search instead.',
    commandNotRecognized: 'Command not recognized. Try again.',
    commandNotImplemented: 'Command not implemented yet',
    failedToProcessCommand: 'Failed to process command',
    locationAccessRequired: 'Location access required',
    searchFailedRetry: 'Search failed. Please try again.',
    
    // Location Errors
    locationPermissionDenied: '📍 Location permission denied. Please enable location in your browser/device settings to report bear sightings.',
    locationUnavailable: '📍 Location unavailable. Make sure GPS is enabled on your device.',
    locationTimeout: '📍 Location request timed out. Please try again in an area with better GPS signal.',
    locationErrorGeneric: '📍 Could not get your location. Please check your location settings and try again.',
    
    // Hazard/Bear Reporting
    failedToReportBear: '⚠️ Failed to report bear. Please check your internet connection and try again.',
    
    // Route Messages
    routeNoLandmarks: 'Route has no landmarks',
    routeNoFinish: 'Route has no finish location',
    failedToExportCache: 'Failed to export cache',
    
    // Dialog Titles
    downloadOfflineMap: 'Download Offline Map',
    
    // Dialog Content
    selectBasin: 'Select which basin you\'ll be working in:',
    selectCounty: 'Select county to filter wells, or search all:',
    searchPlaceholderFull: 'Search wells, operators, API numbers...',
    
    // Onboarding/Help
    voiceSearchTitle: 'Voice Search',
    voiceSearchDesc: 'iOS native voice + Android system voice. Hands-free facility search while driving.',
    voiceSearchIOS: 'iOS: Tap "Tap to Voice Search" and speak',
    voiceSearchAndroid: 'Android: Tap search box, then the mic button (bottom left)',
    dayAndNight: 'Day & Night',
    chipComingSoon: '🔜 Coming Soon',
    chipOptOut: 'Opt-Out',
    chip32Types: '32 Types',
    chip3Options: '3 Options',
    chip7Live30Coming: '7 Live • 30+ Coming',
    chipCDLReady: 'CDL Ready',
    chipGoogleM3: 'Google M3',
    chipGlobalCDN: 'Global CDN',
    fabButtonsTitle: 'FAB Buttons',
    tapToOpen: '• Tap: Open feature',
    longPressToDrag: '• Long press: Drag to rearrange',
    moveFabsBetweenZones: '• Move FABs between top, left, right, bottom zones',
    
    // SearchResults UI
    selectALetter: 'Select a first letter to drill down',
    removeFromFavoritesTooltip: 'Remove from Favorites',
    addToFavoritesTooltip: 'Add to Favorites',
    viewOnMapTooltip: 'View on Map',
    shareTooltip: 'Share',
    inAppNavTooltip: 'In-App Nav',
    googleTooltip: 'Google',
    appleTooltip: 'Apple',
    wazeTooltip: 'Waze',
    photoGalleryTooltip: 'Photo Gallery',
    shownOfTotal: '{0}/{1} shown',
    loadingMore: 'Loading more...',
    facilityPhotos: '{0} Photos',
    
    // Crew Panel
    timesheet: 'Timesheet',
    refresh: 'Refresh',
    locationSharing: 'Location Sharing',
    locationVisible: 'Your location is visible to crew members',
    locationPrivate: 'Your location is private (BYOD friendly)',
    createCrew: 'Create Crew',
    joinCrew: 'Join Crew',
    description: 'Description (optional)',
    descriptionPlaceholder: 'What\'s this crew for?',
    create: 'Create',
    inviteCode: 'Invite Code',
    inviteCodePlaceholder: 'e.g., ABC123',
    join: 'Join',
    members: 'members',
    member: 'member',
    inviteCodeCopied: 'Invite code copied!',
    inviteShared: 'Invite shared!',
    confirmLeave: 'Are you sure you want to leave this crew?',
    leftCrew: 'You left the crew',
    confirmDelete: 'Are you sure you want to delete this crew? This action cannot be undone.',
    crewDeleted: 'Crew deleted',
    activeMeetings: 'Active Meetings',
    checkIns: '{0} check-ins',
    radiusMeters: '{0}m radius',
    checkIn: 'Check In',
    setMeetingPoint: 'Set Meeting Point',
    leadTimesheetSettings: 'Lead & Timesheet Settings',
    createMeetingPoint: 'Create Meeting Point',
    meetingLocationDesc: 'This will create a meeting point at your current location.',
    meetingName: 'Meeting Name',
    meetingNamePlaceholder: 'e.g., Morning Standup',
    checkInRadius: 'Check-in Radius: {0}m',
    makeAdmin: 'Make Admin',
    removeAdmin: 'Remove Admin',
    removeFromCrew: 'Remove from Crew',
    scanToJoin: 'Scan to Join',
    orShareCode: 'Or share this code:',
    leadName: 'Lead/Supervisor Name',
    leadNamePlaceholder: 'e.g., John Smith',
    leadEmail: 'Lead Email',
    leadEmailPlaceholder: 'e.g., lead@company.com',
    companyName: 'Company Name',
    companyNamePlaceholder: 'e.g., ABC Energy Services',
    autoSubmitTimesheet: 'Auto-submit timesheet weekly',
    submitOn: 'Submit On',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    settingsSaved: 'Settings saved!',
    timesheetSettingsDesc: 'Configure where weekly timesheets are sent automatically.',
    liveMemberLocations: 'Live Member Locations',
    noMembersSharedLocation: 'No members have shared their location recently.',
    submitWeeklyTimesheet: 'Submit Weekly Timesheet',
    timesheetSubmitDesc: 'This will submit the current week\'s timesheet to your lead ({0}).',
    noEmailConfigured: 'no email configured',
    week: 'Week',
    notesOptional: 'Notes (optional)',
    notesPlaceholder: 'Any additional notes for your lead...',
    noLeadEmailWarning: 'No lead email configured. Please set up lead settings first.',
    submitToLead: 'Submit to Lead',
    locationNotAvailable: 'Location not available. Please enable location services.',
    roleUpdated: 'Role updated to {0}',
    memberRemoved: 'Member removed',
    failedToShare: 'Failed to share invite',
    confirmRemove: 'Remove {0}?',
    notPartOfCrews: "You're not part of any crews yet.",
    createOrJoinCrew: 'Create one or join with an invite code!',
    
    // MorningPulse
    loadingBasinPulse: 'Loading basin pulse...',
    unableToLoadPulse: 'Unable to Load Basin Pulse',
    noDataAvailable: 'No data available',
    tryAgain: 'Try Again',
    activeCount: 'active',
    hazard: 'hazard',
    hazards: 'hazards',
    homeSafe: 'home safe',
    activeHazards: 'Active Hazards',
    worker: 'Worker',
    reports: 'reports',
    confirms: 'confirms',
    homeSafeCheck: 'Home safe ✓',
    madeItHome: 'Made it home',
    guardian: 'guardian',
    trusted: 'trusted',
    verified: 'verified',
    activeWorker: 'active',
    newWorker: 'new',
    
    // ErrorBoundary
    somethingWentWrong: 'Something went wrong',
    errorDescription: 'The app encountered an unexpected error. Your saved favorites are safe - try reloading.',
    reloadApp: 'Reload App',
    
    // ProductionChart
    loadingProductionData: 'Loading production data...',
    productionDataUnavailable: 'Production data may not be available for all wells',
    
    // SuggestionsDialog
    suggestFeature: 'Suggest a Feature',
    featureRequest: 'Feature Request',
    bugReport: 'Bug Report',
    improvement: 'Improvement',
    thankYou: 'Thank You!',
    suggestionSubmitted: 'Your suggestion has been submitted. We appreciate your feedback!',
    category: 'Category',
    title: 'Title',
    titlePlaceholder: 'Brief summary of your suggestion',
    suggestionDescription: 'Description',
    suggestionDescriptionPlaceholder: 'Describe your suggestion in detail. What problem does it solve? How would it work?',
    submitSuggestion: 'Submit Suggestion',
    submitting: 'Submitting...',
    fillBothFields: 'Please fill in both title and description',
    newFeature: 'New Feature',
    navigation: 'Navigation',
    mapMarkers: 'Map & Markers',
    other: 'Other',
    
    // DrawOverAppsPrompt
    drawOverEnhanceNav: 'Enhance Your Navigation',
    drawOverDesc: 'Enable "Draw Over Apps" permission for Telegram to make it easier to return to ZiaWellNav while using other apps.',
    drawOverWhyEnable: 'Why Enable Draw Over Apps?',
    drawOverWhyEnableDesc: 'When you switch away from Telegram to another app, ZiaWellNav can show navigation overlays on top of your screen. This makes it easier to get back to navigation without opening Telegram again.',
    drawOverOpenSettings: 'Open Settings',
    drawOverOpenSettingsDesc: 'Tap the button below to open your device settings. Look for "Display over other apps" or "Draw over other apps" permission.',
    drawOverEnableForTelegram: 'Enable for Telegram',
    drawOverEnableForTelegramDesc: 'Find Telegram in the list and enable the permission. Once enabled, come back here and tap "Done".',
    drawOverSkip: 'Skip for now',
    drawOverNext: 'Next',
    drawOverDone: 'Done',
    
    // GoHomeFAB
    goHomeSetLocation: 'Set Home Location',
    goHomeUpdateLocation: 'Update Home Location',
    goHomeTooltip: 'Go to {0} (hold to edit)',
    goHomeTooltipNoHome: 'Set Home Location',
    goHomeLocationDesc: 'Your home location is used for the "Go Home" navigation and to auto-stop the timer when you arrive.',
    goHomeCurrent: 'Current: <strong>{0}</strong>',
    goHomeLocationCaptured: 'Location captured!',
    goHomeUseCurrentLocation: 'Use Current Location',
    goHomeGettingLocation: 'Getting Location...',
    goHomeNameLabel: 'Home Name (optional)',
    goHomeNamePlaceholder: 'e.g., My House, The Ranch',
    goHomeSaveButton: 'Save Home',
    goHomeNavigateQuestion: 'Navigate Home?',
    goHomeNavigateTo: 'Navigate to <strong style="color: {0}">{1}</strong>?',
    goHomeNavigateDesc: 'This will open Google Maps with directions to your home location.',
    goHomeAutoStopNote: '✓ Timer will auto-stop when you arrive',
    goHomeGoButton: 'Go Home',
    goHomeNavigateTitle: '🏠 Navigate Home',
    goHomeNavigateMessage: 'Go to {0}',
    goHomeGoogleMaps: '🗺️ Google Maps',
    goHomeAppleMaps: '🍎 Apple Maps',
    goHomeWaze: '👻 Waze',
    goHomeToastSaved: '🏠 Home location saved!',
    goHomeToastFailed: 'Failed to save home location',
    goHomeToastLocationCaptured: '📍 Location captured! Add a name and save.',
    goHomeToastGeoNotSupported: 'Geolocation is not supported by your browser',
    goHomeToastLocationError: 'Could not get location',
    goHomeToastPermissionDenied: 'Location permission denied. Please enable location in your browser settings.',
    goHomeToastLocationUnavailable: 'Location unavailable. Please try again.',
    goHomeToastLocationTimeout: 'Location request timed out. Please try again.',
    goHomeToastNavigating: '🚗 Navigating home...',
    
    // WorkTimerFAB
    workTimerStartTooltip: 'Start Timer',
    workTimerPauseTooltip: 'Pause (hold to stop)',
    workTimerResumeTooltip: 'Resume (hold to stop)',
    workTimerSelectCrew: 'Select Crew for Time Entry',
    workTimerWhichCrew: 'Which crew should this time be logged to?',
    workTimerStopQuestion: 'Stop Timer?',
    workTimerCurrentTime: 'Current time: <strong style="color: {0}">{1}</strong>',
    workTimerLoggingTo: 'Logging to: {0}',
    workTimerKeepRunning: 'Keep Running',
    workTimerStopButton: 'Stop Timer',
    workTimerYoureHome: "You're Home!",
    workTimerArrivedAt: "It looks like you've arrived at <strong>{0}</strong>.",
    workTimerTotalTime: 'Total time: <strong style="color: {0}">{1}</strong>',
    workTimerStopQuestion2: 'Would you like to stop the timer?',
    workTimerFailedStart: 'Failed to start',
    workTimerFailedPause: 'Failed to pause',
    workTimerFailedResume: 'Failed to resume',
    workTimerFailedStop: 'Failed to stop',
    
    // UserSupportFAB
    userSupportTooltip: 'Contact Support ($1/message)',
    
    // VPNWarningSnackbar
    vpnWarningMessage: 'VPN detected! This may affect navigation accuracy. Consider disabling your VPN for better GPS performance.',
    vpnDetected: 'VPN Detected',
    vpnLearnMore: 'Learn More',
    vpnWhyAffects: 'Why does VPN affect navigation?',
    vpnInterferenceIntro: 'VPNs can interfere with location services in several ways:',
    vpnIPLocation: 'IP-based location may show wrong area',
    vpnGPSBackup: 'Some GPS services use network location as backup',
    vpnMapTiles: 'Map tile loading may be slower',
    vpnBestResults: 'For best results in the oil field, disable VPN while navigating.',
    
    // OfflineSyncIndicator
    offlineTooltip: 'Offline - {0} submission{1} pending',
    offlineSyncing: 'Syncing...',
    offlinePendingTap: '{0} pending - Tap to sync',
    offlineAllSynced: 'All synced',
    
    // ExpiredTrialBanner
    trialEnded: 'Your trial has ended. Upgrade to unlock all premium features!',
    trialEndingSoon: '{0} — Upgrade now to keep access',
    upgradeNow: '✨ Upgrade Now',
    
    // SearchPanel
    searchButtonText: 'Search wells by API, operator, or location...',
    searchInputPlaceholder: 'Search wells...',
    searchResultsWillAppear: 'Search results will appear here...',
    
    // TelegramLogin
    telegramLoginLoading: 'Loading...',
    telegramLoginOpenBot: 'Open @{0} in Telegram',
    
    // QRShareDialog
    qrShareTitle: 'Share ZiaWellNav',
    qrLoadingReferral: 'Loading referral info...',
    qrSuccessfulReferrals: '{0} successful referral{1}!',
    qrScanOrShare: 'Scan this QR code or share the link below',
    qrCopyLink: 'Copy Link',
    qrCopied: 'Copied!',
    qrShareButton: 'Share',
    qrEarnCredits: 'Earn Credits by Sharing',
    qrFreeUserSignup: 'Free user signs up',
    qrUserConvertsPaid: 'User converts to paid',
    qrBusinessSignup: 'Business signs up',
    qrFiveReferrals: '5 referrals milestone',
    qrFreeMonth: '1 FREE MONTH',
    qrShareText: '🛢️ Check out ZiaWellNav - the ultimate oil field navigation app!\n\n📍 Find wells, rigs, and SWDs across the Permian Basin\n🗺️ Turn-by-turn GPS navigation to any facility\n👥 Create and manage your crews\n🔧 Find oilfield services near you\n\nFREE while in development! Join now:',
    
    // PollenAlertWidget
    pollenLoadingData: 'Loading pollen data...',
    pollenLabel: 'Pollen',
    pollenPlantsInSeason: '{0} plants in season',
    pollenInSeasonPlants: 'In-Season Plants:',
    pollenMorePlants: '+{0} more',
    
    // NearbyServicesWidget
    nearbyServicesTitle: 'Nearby Services',
    nearbyGasStations: 'Gas Stations',
    nearbyRestaurants: 'Restaurants',
    nearbyHotels: 'Hotels',
    nearbyMedical: 'Medical',
    nearbyAutoRepair: 'Auto Repair',
    nearbyStores: 'Stores',
    nearbyATMs: 'ATMs',
    nearbyFindingPlaces: 'Finding nearby {0}...',
    nearbyNoPlaces: 'No {0} found within 20 miles',
    nearbyNavigateTo: '🧭 Navigate to {0}',
    nearbyChooseApp: 'Choose navigation app',
    nearbyGoogleMaps: '🗺️ Google Maps',
    nearbyAppleMaps: '🍎 Apple Maps',
    nearbyWaze: '👻 Waze',
    nearbyOpenNow: 'Open now',
    nearbyClosed: 'Closed',
    nearbyOpen: 'Open',
    nearbyGetDirections: 'Get Directions',
    
    // AutoCaptureCamera
    cameraError: 'Camera Error',
    cameraStarting: 'Starting camera...',
    
    // AirQualityWidget
    aqiPrefix: 'AQI',
    aqiError: 'AQI: {0}',
    aqiGood: 'Good',
    aqiModerate: 'Moderate',
    aqiUnhealthySensitive: 'Unhealthy (Sensitive)',
    aqiUnhealthy: 'Unhealthy',
    aqiVeryUnhealthy: 'Very Unhealthy',
    aqiHazardous: 'Hazardous',
    aqiRespiratoryWarning: 'Consider respiratory protection',
    aqiIndexLabel: 'Air Quality Index',
    aqiPollutants: 'Pollutants',
    aqiHealthAdvisory: 'Health Advisory',
    aqiUpdated: 'Updated: {0}',
    aqiDataUnavailable: 'Air quality data unavailable',
    aqiFetchFailed: 'Air quality fetch failed',
    
    // ElevationWidget
    elevSafe: 'SAFE',
    elevCaution: 'CAUTION',
    elevWarning: 'WARNING',
    elevDanger: 'DANGER',
    elevProfile: 'Elevation Profile',
    elevFailed: 'Failed to fetch elevation',
    elevUnavailable: 'Elevation unavailable',
    elevMaxGrade: 'Max Grade',
    elevTotalAscent: 'Total Ascent',
    elevTotalDescent: 'Total Descent',
    elevFeet: 'ft',
    elevMiles: 'mi',
    elevUphill: 'Uphill',
    elevDownhill: 'Downhill',
    elevGrade: 'Grade',
    elevLoading: 'Calculating elevation...',
    
    // WeatherOverlay
    weatherWindCalm: 'CALM',
    weatherWindModerate: 'MODERATE',
    weatherWindCaution: 'CAUTION - GUSTY',
    weatherWindWarning: 'WARNING - STRONG WIND',
    weatherWindDanger: 'DANGER - HIGH WIND',
    weatherWindHurricane: 'HURRICANE FORCE',
    weatherFloodLow: 'Low flood risk',
    weatherFloodModerate: 'Moderate flood risk - Be cautious near dry washes',
    weatherFloodHigh: '⚠️ HIGH flash flood risk - Avoid low areas and washes!',
    weatherFloodExtreme: '⚠️ EXTREME FLASH FLOOD RISK - Seek high ground immediately!',
    weatherThunderstormWarning: 'Thunderstorm Warning',
    weatherHeavyRain: 'Heavy Rain Alert',
    weatherWind: 'Wind',
    weatherTemp: 'Temp',
    weatherFeelsLike: 'Feels Like',
    weatherHumidity: 'Humidity',
    weatherVisibility: 'Visibility',
    weatherUVIndex: 'UV Index',
    weatherPrecipProb: 'Precip',
    weatherUpdated: 'Updated: {0}',
    weatherUnavailable: 'Weather data unavailable',
    weatherFetchFailed: 'Weather fetch failed',
    weatherNotConfigured: 'Weather API not configured',
    
    // StreetViewModal
    streetViewTitle: 'Street View Preview',
    streetViewNorth: 'North',
    streetViewEast: 'East',
    streetViewSouth: 'South',
    streetViewWest: 'West',
    streetViewNotAvailable: 'Street View not available at this location',
    streetViewUnavailable: 'Street View unavailable',
    streetViewLoading: 'Loading Street View...',
    streetViewFailed: 'Failed to load Street View',
    streetViewRotateLeft: 'Rotate left',
    streetViewRotateRight: 'Rotate right',
    streetViewPitchUp: 'Look up',
    streetViewPitchDown: 'Look down',
    streetViewClose: 'Close',
    streetViewPanorama: 'Full Panorama',
    streetViewMetadata: 'Street View Metadata',
    
    // PhotoGallery
    photoNoPhotos: 'No photos yet',
    photoTapToAdd: 'Tap to add the first photo',
    photoDeleteConfirm: 'Delete this photo? This cannot be undone.',
    photoDeleted: 'Photo deleted',
    photoDeleteFailed: 'Failed to delete photo',
    photoReportTitle: 'Report Photo',
    photoReportMessage: 'Why are you reporting this photo?',
    photoReportInappropriate: '🚫 Inappropriate',
    photoReportWrongLocation: '❌ Wrong Location',
    photoReportSpam: '📧 Spam',
    photoReportSubmitted: 'Report submitted. Thank you!',
    photoReportFailed: 'Failed to submit report',
    photoOf: 'Photo {0} of {1}',
    photoFullscreen: 'View fullscreen',
    photoSwipeToNavigate: 'Swipe to navigate',
    photo360: '360°',
    photoFacilityPhoto: 'Facility photo',
    photoDelete: 'Delete',
    photoReport: 'Report',
    
    // OnboardingDialog
    onboardingTitle: 'Offline Data',
    onboardingSubtitle: 'Download for field use',
    onboardingDescription: 'Access wells & facilities even without cell signal.',
    onboardingPriority: '⭐ Priority',
    onboardingRecommended: 'Recommended',
    onboardingAllCounties: '📦 All Counties',
    onboardingCompleteCoverage: 'Complete coverage • 32 NM counties',
    onboardingFastCDN: 'Fast CDN Mode',
    onboardingDontShowAgain: 'Don\'t show again',
    onboardingDownloading: 'Downloading...',
    onboardingSkipForNow: 'Skip for now',
    onboardingContinueUsing: 'Continue Using App',
    onboardingBackgroundNote: 'You can close this and continue using the app. Downloads run in background.',
    onboardingRemaining: '{0} remaining',
    
    // LocationPermissionDialog  
    locationPermissionTitle: 'Location Access',
    locationPermissionDescription: 'ZiaWellNav wants to access your location',
    locationPermissionGrant: 'Allow',
    locationPermissionLater: 'Not Now',
    locationPermissionNever: 'Never Allow',
    locationPermissionIndefinitely: 'Allow Indefinitely',
    locationPermissionIndefinitelyDesc: 'Always allow location access without asking again',
    locationPermissionSession: 'Allow While Using App',
    locationPermissionSessionDesc: 'Allow until you close the app or for 24 hours',
    locationPermissionOnce: 'Allow Once',
    locationPermissionOnceDesc: 'Allow just this one time, ask again next time',
    
    // SubscriptionPanel
    subscriptionTitle: 'Upgrade to Premium',
    subscriptionMonthly: 'Monthly',
    subscriptionYearly: 'Yearly',
    subscriptionFreeTrial: 'Free Trial',
    subscriptionSubscribe: 'Subscribe Now',
    subscriptionCancel: 'Cancel Anytime',
    subscriptionFeature1: 'Unlimited searches',
    subscriptionFeature2: 'Offline maps',
    subscriptionFeature3: 'Premium support',
    
    // WellDetailsModal
    wellDetailsTitle: 'Well Details',
    wellDetailsAPI: 'API Number',
    wellDetailsOperator: 'Operator',
    wellDetailsStatus: 'Status',
    wellDetailsType: 'Type',
    wellDetailsLocation: 'Location',
    wellDetailsElevation: 'Elevation',
    wellDetailsDepth: 'Depth',
    wellDetailsProduction: 'Production',
    wellDetailsClose: 'Close',
    
    // AddFacilityForm
    addFacilityTitle: 'Add Facility',
    addFacilityName: 'Facility Name',
    addFacilityType: 'Facility Type',
    addFacilityLocation: 'Location',
    addFacilityNotes: 'Notes',
    addFacilitySubmit: 'Submit',
    addFacilityCancel: 'Cancel',
    
    // HomeSpeedDial
    homeAndLocation: 'Home & Location',
    homeResetMapView: 'Reset Map View',
    homeSetLocation: 'Set Home Location',
    homeUpdateHome: 'Update Home',
    homeNavigateHome: 'Navigate Home',
    
    // FriendsPanel
    friendsTitle: 'Friends',
    friendsShareInvite: 'Share Invite Link',
    friendsShareLocation: 'Share My Location',
    friendsShareLocationDesc: 'Let friends see your real-time location on the map',
    friendsTabFriends: 'Friends',
    friendsTabRequests: 'Requests',
    friendsAddByUsername: 'Add Friend by Username',
    friendsNoFriends: 'No friends yet. Add friends to share locations!',
    friendsNoPendingRequests: 'No pending friend requests',
    friendsLocationAvailable: 'Location available',
    friendsWaitingLocation: 'Waiting for location...',
    friendsLocationNotShared: 'Location not shared',
    friendsStopSharing: 'Stop sharing location',
    friendsStartSharing: 'Share your location',
    friendsNavigateTo: 'Navigate to friend',
    friendsRemoveFriend: 'Remove friend',
    friendsAddFriend: 'Add Friend',
    friendsEnterUsername: 'Enter your friend\'s Telegram username',
    friendsSendRequest: 'Send Request',
    friendsWantsToBeFriend: 'Wants to be your friend',
  },
  es: {
    // Search
    searchPlaceholder: 'Diga el # API, Nombre del Pozo, o Tipo',
    searchPlaceholderHint: 'ej. "compresor" o "quemador"',
    searchResults: 'Resultados de Búsqueda',
    noResults: 'No se encontraron resultados',
    byFacilityType: 'Por Tipo de Instalación',
    noFilteredResults: 'Ningún resultado coincide con tus filtros. Ajusta o limpia los filtros.',
    tryDifferentSearch: 'Prueba otra búsqueda o revisa tus filtros',
    letters: 'Letras',
    secondLetters: 'Segunda letra',
    thirdLetters: 'Tercera letra',
    fourthLetters: 'Cuarta letra',
    loadingResults: 'Cargando resultados...',
    noTypeFound: 'No se encontraron {0}',
    showingCountOf: 'Mostrando {0} de {1} resultados',
    searchingFor: 'Buscando',
    results: 'resultados',
    result: 'resultado',
    cachedLabel: 'en caché',
    liveLabel: 'en vivo',
    
    // Navigation
    navigate: 'Navegar',
    getDirections: 'Obtener Direcciones',
    startNavigation: 'Iniciar Navegación',
    
    // Favorites
    favorites: 'Favoritos',
    noFavorites: 'Aún no hay instalaciones guardadas',
    tapToSave: 'Toca el ícono de estrella para guardar',
    savedFacilities: 'instalaciones guardadas',
    savedFacility: 'instalación guardada',
    removeFromFavorites: 'Eliminar de favoritos',
    addToFavorites: 'Agregar a favoritos',
    
    // Facility types
    all: 'Todo',
    well: 'Pozo',
    rig: 'Plataforma',
    swd: 'SWD',
    facility: 'Instalación',
    wells: 'Pozos',
    rigs: 'Plataformas',
    swds: 'SWDs',
    tankBattery: 'Batería de Tanques',
    flareStack: 'Quemador',
    compressor: 'Compresor',
    gasPlant: 'Planta de Gas',
    brineWell: 'Pozo de Salmuera',
    refinery: 'Refinería',
    treatingPlant: 'Planta de Tratamiento',
    wellHead: 'Cabezal de Pozo',
    gasGathering: 'Recolección de Gas',
    injectionPlant: 'Planta de Inyección',
    gasPipeline: 'Tubería de Gas',
    crudePipeline: 'Tubería de Crudo',
    waterPipeline: 'Tubería de Agua',
    gasStorage: 'Almacén de Gas',
    belowGradeTank: 'Tanque Subterráneo',
    meteringStation: 'Estación de Medición',
    crudePump: 'Bomba de Crudo',
    pits: 'Fosas',
    wasteMgmt: 'Gestión de Residuos',
    recycling: 'Reciclaje',
    remediate: 'Remediación',
    abatement: 'Mitigación',
    serviceCo: 'Servicio',
    classIII: 'Clase I/II',
    portaPotty: 'Letrina Portátil',
    wellPad: 'Plataforma de Pozo',
    location: 'Ubicación',
    activeOps: 'Ops Activas',
    more: 'Más...',
    tacoTruck: 'Camión de Tacos',
    tacoTruckName: 'Nombre del Camión',
    enterTruckName: 'Ingresa el nombre del camión de tacos',
    tacoTruckMarked: 'Ubicación del camión de tacos marcada',
    tacoNameExists: 'Un camión de tacos con este nombre ya existe hoy',
    showTacoLocations: 'Mostrar ubicaciones de camiones de tacos',
    searchFacilityTypes: 'Buscar en 33 Tipos de Instalaciones',
    treating: 'Tratamiento',
    injection: 'Inyección',
    gasLine: 'Línea de Gas',
    crudeLine: 'Línea de Crudo',
    waterLine: 'Línea de Agua',
    gasGather: 'Rec. de Gas',
    metering: 'Medición',
    belowGrade: 'Subterráneo',
    
    // Actions
    copy: 'Copiar',
    copied: '¡Copiado!',
    apiCopied: 'API {0} copiado!',
    delete: 'Eliminar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    close: 'Cerrar',
    save: 'Guardar',
    share: 'Compartir',
    saveSettings: 'Guardar Configuración',
    submit: 'Enviar',
    add: 'Agregar',
    remove: 'Quitar',
    edit: 'Editar',
    
    // Status
    loading: 'Cargando...',
    offline: 'Sin Conexión',
    online: 'En Línea',
    active: 'Activo',
    inactive: 'Inactivo',
    error: 'Error',
    success: 'Éxito',
    
    // FAB tooltips
    addFacility: 'Agregar Nueva Instalación',
    activeOperations: 'Operaciones Activas',
    toggleTheme: 'Cambiar Tema',
    toggleLanguage: 'Switch to English',
    viewOnMap: 'Ver en Mapa',
    lightMode: 'Modo Claro',
    darkMode: 'Modo Oscuro',
    highContrast: 'Alto Contraste',
    normalContrast: 'Contraste Normal',
    
    // Map
    mapView: 'Vista de Mapa',
    listView: 'Vista de Lista',
    satellite: 'Satélite',
    terrain: 'Terreno',
    
    // Filters
    allCounties: 'Todos los Condados',
    filterByCounty: 'Filtrar por Condado',
    filterByType: 'Filtrar por Tipo',
    filterByOperator: 'Filtrar por Operador',
    filterByStatus: 'Filtrar por Estado',
    allStatus: 'Todos los Estados',
    allTypes: 'Todos los Tipos',
    allOperators: 'Todos los Operadores',
    sortAZ: 'Ordenar A-Z',
    sortZA: 'Ordenar Z-A',
    clearFilters: 'Limpiar Filtros',
    filter: 'filtro',
    filters: 'filtros',
    
    // Voice
    tapToSpeak: 'Toca para hablar',
    searchHint: 'Diga el # API, Nombre del Pozo, o Tipo',
    searchHintFallback: 'ej. "compresor" o "quemador"',
    listening: 'Escuchando...',
    voiceNavigation: 'Navegación por Voz',
    speakDestination: 'Diga su destino',
    recentSearches: 'Búsquedas Recientes:',
    searchBelow: 'Escribe para Buscar',
    voiceNotSupported: 'Voz no disponible',
    
    // Facility details
    apiNumber: 'Número API',
    operator: 'Operador',
    county: 'Condado',
    status: 'Estado',
    distance: 'Distancia',
    miles: 'millas',
    feet: 'pies',
    coordinates: 'Coordenadas',
    lat: 'LAT',
    lng: 'LNG',
    latitude: 'Latitud',
    longitude: 'Longitud',
    wellName: 'Nombre del Pozo',
    wellType: 'Tipo de Pozo',
    pool: 'Piscina',
    district: 'Distrito',
    township: 'Municipio',
    range: 'Rango',
    section: 'Sección',
    
    // Directions
    turnLeft: 'Gire a la izquierda',
    turnRight: 'Gire a la derecha',
    continueOn: 'Continúe en',
    arrive: 'Llegue a su destino',
    inMiles: 'en {0} millas',
    inFeet: 'en {0} pies',
    
    // Onboarding
    welcome: 'Bienvenido',
    getStarted: 'Comenzar',
    skip: 'Omitir',
    next: 'Siguiente',
    back: 'Atrás',
    
    // Errors
    locationError: 'No se pudo obtener su ubicación',
    networkError: 'Error de red. Inténtelo de nuevo.',
    searchError: 'Error en la búsqueda. Inténtelo de nuevo.',
    
    // Time
    lastUpdated: 'Última actualización',
    justNow: 'Ahora mismo',
    minutesAgo: 'hace {0} minutos',
    hoursAgo: 'hace {0} horas',
    
    // Crews
    myCrews: 'Mis Equipos',
    addCrew: 'Agregar Equipo',
    crewName: 'Nombre del Equipo',
    crewMembers: 'Miembros del Equipo',
    
    // Landing Page - Hero Section
    heroTagline: 'La Mitad del Precio. El Doble de Funciones.',
    heroSubtagline: 'Navegación Petrolera Impulsada por la Comunidad',
    heroDescription: '$10/mes • 424,243 pozos entre NM y TX • Navegación Google Maps + rutas de caliche = rutas que te meten y te sacan de cualquier pozo en el oilfield',
    alreadyUsingZia: '¿Ya usas Zia?',
    openBot: 'Abrir @ziawellnavbot',
    advancedFeaturesTitle: 'Funciones Avanzadas',
    advancedFeaturesDesc: 'Hecho por trabajadores petroleros, para trabajadores petroleros. Herramientas potentes para el campo petrolero moderno.',
    
    // Landing Page - Feature Cards
    comingSoon: 'Próximamente',
    premium: 'Premium',
    exclusive: 'Exclusivo',
    voiceNavigationTitle: 'Navegación por Voz',
    voiceNavigationDesc: 'Búsqueda sin manos con transcripción de Telegram Premium',
    voiceNavigationSubtext: 'Habla para buscar, Telegram maneja la transcripción',
    telegramChannelsTitle: 'Canales de Telegram',
    telegramChannelsDesc: 'Canales privados, mensajería segura y transmisión de video',
    telegramChannelsSubtext: 'Todo integrado en Telegram',
    facilityTypesTitle: '32 Tipos de Instalaciones',
    facilityTypesDesc: 'Pozos, tanques, compresores, tuberías, SWDs y más',
    facilityTypesSubtext: 'La mayoría de navegadores solo cubren pozos básicos',
    dragDropLandmarksTitle: 'Arrastrar y Soltar Marcadores',
    dragDropLandmarksDesc: 'Coloca marcadores en guardaganados, molinos y curvas. Traza rutas por territorio sin marcar y encuentra la salida cuando estés en terreno desconocido.',
    amigosTitle: 'Amigos',
    amigosDesc: 'Próximamente - Comparte tu ubicación con amigos y véanse en tiempo real en el mapa.',
    offlineMapsTitle: 'Mapas Sin Conexión',
    offlineMapsDesc: 'Descarga cuencas enteras para acceso sin conexión. ¿Sin señal? No hay problema.',
    weatherAlertsTitle: 'Clima y Peligros',
    weatherAlertsDesc: 'Datos climáticos en tiempo real y advertencias de peligros en la carretera para mantenerte seguro.',
    crewTrackingTitle: 'Rastreo de Equipos',
    crewTrackingDesc: 'Ve las ubicaciones de tu equipo en tiempo real. Coordina mejor, trabaja más seguro.',
    basinCommunitiesTitle: 'Comunidades de Cuenca',
    basinCommunitiesDesc: 'Conéctate con operadores en tu cuenca. Comparte información, encuentra equipos, publica trabajos.',
    oilfieldMappingTitle: 'Mapeo de Campos Petroleros',
    oilfieldMappingDesc: '424,243 pozos en la base de datos. 284,883 pozos en TX (36 condados del Permian Basin) + 139,360 en NM (32 condados). Encuentra locaciones de construcción antes de que aparezcan en cualquier mapa oficial.',
    oilfieldMappingSubtext: 'Ve a dónde se mueve la plataforma antes de que llegue.',
    calicheRoutesTitle: 'Rutas de Caliche',
    calicheRoutesDesc: 'Navega caminos que Google no conoce. Traza rutas por caminos petroleros sin marcar, marca puntos de referencia y comparte con tu equipo.',
    calicheRoutesSubtext: 'Nunca te pierdas regresando a casa—incluso en territorio desconocido.',
    wellsNearYouTitle: 'Pozos Cerca de Ti',
    wellsNearYouDesc: 'Encuentra instantáneamente los pozos, plataformas e instalaciones más cercanas según tu ubicación GPS.',
    heavyHaulDirectoryTitle: 'Directorio de Transporte Pesado',
    heavyHaulDirectoryDesc: 'Encuentra operadores de transporte pesado, servicios de camiones y alquiler de equipos en tu área.',
    jobsBoardTitle: 'Tablero de Trabajos',
    jobsBoardDesc: 'Publica trabajos, encuentra trabajo, haz ofertas en contratos. Conéctate directamente con operadores y contratistas.',
    hazardsAlertsTitle: 'Alertas de Peligros y Policía',
    hazardsAlertsDesc: 'Alertas de seguridad comunitaria. Reporta peligros en carreteras, policías e incidentes. Mantente seguro.',
    aiAssistantTitle: 'Copiloto IA (Grok)',
    aiAssistantDesc: 'Tu IA personal que construye memoria de tus rutas, paradas frecuentes y patrones de trabajo. Cuanto más manejas, más inteligente se vuelve.',
    aiAssistantSubtext: '🧠 Aprende tu rutina diaria—mejorando constantemente',
    privacyFirstTitle: 'Diseño que Prioriza la Privacidad',
    privacyFirstDesc: 'No se necesita cuenta. Claves API ocultas del lado del servidor. Tu ubicación nunca se almacena. Reportes de peligros anónimos.',
    privacyFirstSubtext: 'Cifrado E2E vía Telegram • Sin rastreo • Sin anuncios 🔒',
    weatherDataTitle: 'Datos del Clima',
    weatherDataDesc: 'Impulsado por Google + Open-Meteo (código abierto suizo). Lluvia, UV, viento, temperatura con conmutación automática.',
    weatherDataSubtext: 'Alertas de inundaciones repentinas para seguridad en arroyos 🌊',
    englishSpanishTitle: 'Inglés y Español',
    englishSpanishDesc: 'Soporte completo de la aplicación en ambos idiomas. Sirviendo a la diversa fuerza laboral del campo petrolero.',
    englishSpanishSubtext: 'Más idiomas en camino',
    crewsTimesheetsTitle: 'Equipos y Hojas de Horas',
    crewsTimesheetsDesc: 'Invitaciones con código QR, rastreo GPS en vivo, puntos de reunión con registros y hojas de horas semanales enviadas automáticamente a tu jefe.',
    crewsTimesheetsSubtext: 'Compatible con BYOD • Compartir ubicación que prioriza la privacidad',
    quadNavigationTitle: 'Navegación Google Maps',
    quadNavigationDesc: 'Soporte completo de waypoints para rutas de caliche. Navega por caminos de tierra sin mapear con coordenadas GPS.',
    quadNavigationSubtext: 'La única app con soporte multi-waypoint',
    googleApisTitle: 'APIs de Google',
    googleApisDesc: '7 APIs de Google integradas ahora: lugares, direcciones, elevación y más. Más de 30 APIs próximamente.',
    googleApisSubtext: 'Capacidades en constante expansión',
    semiHazmatTitle: 'Rutas para Camiones y Materiales Peligrosos',
    semiHazmatDesc: 'Enrutamiento optimizado para camiones y cargas de materiales peligrosos. Evita puentes bajos, límites de peso y carreteras restringidas.',
    semiHazmatSubtext: 'Diseñado para conductores profesionales',
    cyberThemeTitle: 'Tema Cibernético',
    cyberThemeDesc: 'Modo oscuro elegante con acentos de neón brillantes para turnos nocturnos. Modo de alto contraste para condiciones de luz diurna brillante.',
    cyberThemeSubtext: 'Fácil para los ojos, 24/7',
    materialDesignTitle: 'Material Design 3',
    materialDesignDesc: 'Construido sobre la última filosofía de Material Design 3 de Google. UI premium con colores dinámicos, elevación y movimiento.',
    materialDesignSubtext: 'El mismo lenguaje de diseño que las aplicaciones de Google',
    cloudflareTitle: 'Protegido por Cloudflare',
    cloudflareDesc: 'Seguridad de nivel empresarial con red global edge. Protección DDoS, SSL y tiempos de carga ultrarrápidos desde más de 300 centros de datos.',
    cloudflareSubtext: 'Base de datos D1 + Workers = respuestas instantáneas ⚡',
    realTimeDataTitle: 'Datos en Tiempo Real',
    realTimeDataDesc: 'Información de instalaciones siempre actualizada extraída de fuentes de datos en vivo',
    realTimeDataSubtext: 'Tus datos se mantienen actuales y precisos',
    offlineTitle: 'Descargar para Sin Conexión',
    offlineDesc: 'Accede a mapas y datos en el desierto, montañas o en cualquier lugar sin señal. Los mapas se descargan automáticamente a tu dispositivo, no se requiere acción.',
    offlineSubtext: 'Descarga los 424,243 pozos para búsqueda sin conexión—NM completo + Permian Basin.',
    basinSafetyTitle: 'Canales de Seguridad de Cuenca',
    basinSafetyDesc: 'Recibe alertas en tiempo real de accidentes, tráfico e incidentes de campo en tu cuenca',
    basinSafetySubtext: 'Permian, Delaware, San Juan y Raton',
    readyToStartTitle: '¿Listo para Comenzar?',
    readyToStartDesc: 'Inicia sesión con Telegram para acceder a datos de instalaciones en tiempo real, navegación por voz y canales de seguridad de cuenca. Toda la comunicación ocurre en Telegram con cifrado de extremo a extremo.',
    freeTrialHeading: '🎁 Prueba Gratuita de 7 Días • No se Requiere Tarjeta de Crédito',
    forFieldProfessionals: 'Para Profesionales de Campo',
    individualPrice: '$10',
    individualSubheading: 'Acceso completo a navegación por voz y alertas de seguridad de cuenca',
    individualFeature1: '✓ Navegación por Voz',
    individualFeature2: '✓ 424,243 Pozos (NM + TX)',
    individualFeature3: '✓ Triple Navegación (Apple/Google/Waze)',
    individualFeature4: '✓ Mapas y Datos Sin Conexión',
    individualFeature5: '✓ Alertas de Peligros Viales',
    individualFeature6: '✓ Rutas de Caliche y Puntos de Referencia',
    individualFeature7: '✓ Rutas para Semis y Hazmat',
    individualFeature8: '✓ Datos del Clima',
    individualFeature9: '✓ Inglés y Español',
    excludedFeature1: '✗ Canales Privados de Empresa',
    excludedFeature2: '✗ Equipos y Hojas de Tiempo',
    excludedFeature3: '✗ Ubicación Compartida del Equipo',
    businessPlansHeading: 'Planes Empresariales',
    starterLabel: 'INICIAL',
    starterPrice: '$7',
    perUserMonth: '/usuario/mes',
    starterRange: '5-25 usuarios',
    teamLabel: 'EQUIPO',
    teamPrice: '$6',
    teamRange: '26-100 usuarios',
    fleetLabel: 'FLOTA',
    fleetPrice: '$5',
    fleetRange: '101-250 usuarios',
    enterpriseLabel: 'EMPRESA',
    enterprisePrice: '$4',
    enterpriseRange: '251+ usuarios',
    founding50Heading: '🏆 Programa Fundadores 50',
    founding50Desc: 'Sé una de las primeras 50 empresas de servicio en unirse',
    founding50Price: '$4/usuario/mes para siempre',
    founding50Spots: 'lugares restantes',
    founding50Locked: 'Tarifa fija para siempre, sin importar el tamaño del equipo',
    allBusinessPlansInclude: 'Todos los Planes Empresariales Incluyen:',
    businessFeature1: '✓ Todo en Individual',
    businessFeature2: '✓ Canales Privados de Empresa',
    businessFeature3: '✓ Equipos y Hojas de Tiempo 🔜',
    businessFeature4: '✓ Amigos - Ubicación del Equipo 🔜',
    businessFeature5: '✓ Canal de Soporte Dedicado',
    businessFeature6: '✓ Integración de Instalaciones Personalizadas',
    businessFeature7: '✓ Descuentos por Volumen (100+ usuarios)',
    comparisonHeading: 'Individual vs Empresarial',
    individualPlanTitle: 'Individual — $10/mes',
    businessPlanTitle: 'Empresarial — $4-7/usuario/mes',
    privacyFirstHeading: '🔒 Tu Privacidad Primero:',
    privacyFirstText: 'No se requiere cuenta: Telegram maneja la autenticación. Todas las claves API (Google, OpenWeather) están solo del lado del servidor; nunca las ves ni las transmites. Tu ubicación se procesa del lado del cliente y nunca se almacena en nuestros servidores. La identidad del reportero de peligros es siempre anónima: solo alertas a nivel de cuenca, sin coordenadas exactas. Cifrado E2E a través de Telegram. Auto-eliminación después de 24 horas. Sin rastreo, sin anuncios, sin ventas de datos.',
    pricingDisclaimer: '💡 Todos los planes incluyen prueba gratuita de 7 días • Cancela en cualquier momento • Recompensas por referencias disponibles',
    loginTermsText: 'Al iniciar sesión, aceptas los',
    termsOfService: 'Términos de Servicio',
    and: 'y la',
    privacyPolicy: 'Política de Privacidad',
    madeWithLove: 'Hecho con ❤️ por',
    ziatechsLink: 'Zia Techs',
    charityText: 'Donamos el 20% de las ganancias a',
    packsForHunger: 'Packs for Hunger',
    copyright: '© 2026 Zia Well Nav',
    
    // Community Impact Section
    communityImpactTitle: 'Impacto Comunitario',
    communityImpactDesc: 'Cada suscripción apoya directamente a los niños de nuestras comunidades petroleras',
    monthlyDonation: 'de suscripciones mensuales',
    annualDonation: 'de suscripciones anuales',
    packsForHungerDesc: 'Packs for Hunger proporciona bolsas de comida de fin de semana a niños que enfrentan inseguridad alimentaria en las escuelas del Condado de Lea. Cada bolsa contiene comidas nutritivas para asegurar que ningún niño pase hambre cuando las comidas escolares no están disponibles.',
    quarterlyImpact: '📊 Publicamos informes de impacto trimestrales mostrando exactamente cómo tu suscripción ayuda a alimentar a niños locales.',
    
    // FAB labels (more comprehensive)
    search: 'Buscar',
    aiAssistant: 'Asistente IA',
    favoritesTooltip: 'Favoritos',
    mapSettings: 'Configuración de Mapa',
    calicheRoutesTooltip: 'Rutas de Caliche',
    activity: 'Actividad',
    jobs: 'Trabajos',
    suggestions: 'Sugerencias',
    timer: 'Temporizador',
    networkStatus: 'Estado de Red',
    qrShare: 'Compartir QR',
    voice: 'Voz',
    services: 'Servicios',
    basinCommunity: 'Comunidad de Cuenca',
    crews: 'Equipos',
    friends: 'Amigos',
    
    // Common UI elements
    openWellNavigator: 'Abrir Navegador de Pozos',
    subscription: 'Suscripción',
    subscriptionInfo: 'Info de Suscripción',
    individual: 'Individual',
    business: 'Empresarial',
    perMonth: '/mes',
    perYear: '/año',
    savePercent: 'Ahorra {0}%',
    choosePlan: 'Elegir Plan',
    features: 'Características',
    
    // Messages & Toasts
    homeSaved: '¡Ubicación de inicio guardada!',
    navigatingHome: 'Navegando a casa...',
    locationCaptured: '¡Ubicación capturada! Agrega un nombre y guarda.',
    geolocationNotSupported: 'La geolocalización no es compatible con tu navegador',
    failedToSave: 'Error al guardar',
    routeDeleted: 'Ruta eliminada',
    routeSaved: 'Ruta guardada',
    photoUploaded: 'Foto subida',
    addFavoritesFirst: '¡Agrega algunos favoritos primero para verlos en el mapa!',
    
    // Directions & Navigation
    findingNearestWell: 'Buscando el pozo más cercano...',
    couldNotSearch: 'No se pudo buscar "{0}". {1}',
    noCachedResults: 'No hay resultados en caché disponibles.',
    pleaseTryAgain: 'Inténtalo de nuevo.',
    
    // Cache & Data
    cacheVerified: 'Caché Verificado: Todos los datos en caché son válidos',
    noCachedData: 'No hay datos en caché para verificar. Descarga algunas cuencas primero.',
    failedToVerify: 'Error al verificar la integridad del caché',
    cacheImported: 'Caché Importado: El caché del equipo se ha fusionado con éxito',
    failedToImport: 'Error al importar el caché',
    historyCleared: 'Historial Borrado: El historial de búsqueda ha sido eliminado',
    failedToClear: 'Error al borrar el historial de búsqueda',
    cacheCleared: 'Caché Borrado: Todos los datos en caché han sido eliminados',
    failedToClearCache: 'Error al borrar el caché',
    dataUpdated: 'Datos Actualizados: Los datos de instalaciones se actualizaron durante la noche',
    
    // Voice Navigation specific
    voiceSearchNotSupported: '¡La búsqueda por voz no es compatible con Telegram en Android. Por favor usa la barra de búsqueda para escribir tu búsqueda, o toca los botones de tipo de instalación abajo!',
    speakToSearch: 'Habla para buscar',
    typeToSearch: 'Escribe para buscar',
    voiceNotSupportedDevice: 'Reconocimiento de voz no compatible con este dispositivo. Intenta escribir tu búsqueda en su lugar.',
    commandNotRecognized: 'Comando no reconocido. Inténtalo de nuevo.',
    commandNotImplemented: 'Comando aún no implementado',
    failedToProcessCommand: 'Error al procesar el comando',
    locationAccessRequired: 'Se requiere acceso a la ubicación',
    searchFailedRetry: 'Error en la búsqueda. Por favor, inténtalo de nuevo.',
    
    // Location Errors
    locationPermissionDenied: '📍 Permiso de ubicación denegado. Por favor habilita la ubicación en la configuración de tu navegador/dispositivo para reportar avistamientos de osos.',
    locationUnavailable: '📍 Ubicación no disponible. Asegúrate de que el GPS esté habilitado en tu dispositivo.',
    locationTimeout: '📍 Tiempo de espera de ubicación agotado. Por favor intenta de nuevo en un área con mejor señal GPS.',
    locationErrorGeneric: '📍 No se pudo obtener tu ubicación. Por favor verifica la configuración de ubicación e inténtalo de nuevo.',
    
    // Hazard/Bear Reporting
    failedToReportBear: '⚠️ Error al reportar oso. Por favor verifica tu conexión a internet e inténtalo de nuevo.',
    
    // Route Messages
    routeNoLandmarks: 'La ruta no tiene puntos de referencia',
    routeNoFinish: 'La ruta no tiene ubicación de finalización',
    failedToExportCache: 'Error al exportar caché',
    
    // Dialog Titles
    downloadOfflineMap: 'Descargar Mapa Sin Conexión',
    
    // Dialog Content
    selectBasin: 'Selecciona en qué cuenca trabajarás:',
    selectCounty: 'Selecciona el condado para filtrar pozos, o busca todos:',
    searchPlaceholderFull: 'Buscar pozos, operadores, números API...',
    
    // Onboarding/Help
    voiceSearchTitle: 'Búsqueda por Voz',
    voiceSearchDesc: 'Voz nativa de iOS + voz del sistema Android. Búsqueda de instalaciones sin manos mientras conduces.',
    voiceSearchIOS: 'iOS: Toca "Toca para Búsqueda por Voz" y habla',
    voiceSearchAndroid: 'Android: Toca la caja de búsqueda, luego el botón del micrófono (abajo a la izquierda)',
    dayAndNight: 'Día y Noche',
    chipComingSoon: '🔜 Próximamente',
    chipOptOut: 'Opcional',
    chip32Types: '32 Tipos',
    chip3Options: '3 Opciones',
    chip7Live30Coming: '7 Activas • 30+ Próximas',
    chipCDLReady: 'Listo CDL',
    chipGoogleM3: 'Google M3',
    chipGlobalCDN: 'CDN Global',
    fabButtonsTitle: 'Botones FAB',
    tapToOpen: '• Tocar: Abrir función',
    longPressToDrag: '• Presión larga: Arrastrar para reorganizar',
    moveFabsBetweenZones: '• Mover FABs entre las zonas superior, izquierda, derecha e inferior',
    
    // SearchResults UI
    selectALetter: 'Selecciona una primera letra para profundizar',
    removeFromFavoritesTooltip: 'Quitar de Favoritos',
    addToFavoritesTooltip: 'Agregar a Favoritos',
    viewOnMapTooltip: 'Ver en el Mapa',
    shareTooltip: 'Compartir',
    inAppNavTooltip: 'Navegación Interna',
    googleTooltip: 'Google',
    appleTooltip: 'Apple',
    wazeTooltip: 'Waze',
    photoGalleryTooltip: 'Galería de Fotos',
    shownOfTotal: '{0}/{1} mostrados',
    loadingMore: 'Cargando más...',
    facilityPhotos: 'Fotos de {0}',
    
    // Crew Panel
    timesheet: 'Hoja de Horas',
    refresh: 'Actualizar',
    locationSharing: 'Compartir Ubicación',
    locationVisible: 'Tu ubicación es visible para los miembros del equipo',
    locationPrivate: 'Tu ubicación es privada (amigable con BYOD)',
    createCrew: 'Crear Equipo',
    joinCrew: 'Unirse al Equipo',
    description: 'Descripción (opcional)',
    descriptionPlaceholder: '¿Para qué es este equipo?',
    create: 'Crear',
    inviteCode: 'Código de Invitación',
    inviteCodePlaceholder: 'ej., ABC123',
    join: 'Unirse',
    members: 'miembros',
    member: 'miembro',
    inviteCodeCopied: '¡Código de invitación copiado!',
    inviteShared: '¡Invitación compartida!',
    confirmLeave: '¿Estás seguro de que quieres salir de este equipo?',
    leftCrew: 'Has salido del equipo',
    confirmDelete: '¿Estás seguro de que quieres eliminar este equipo? Esta acción no se puede deshacer.',
    crewDeleted: 'Equipo eliminado',
    activeMeetings: 'Reuniones Activas',
    checkIns: '{0} registros',
    radiusMeters: 'radio de {0}m',
    checkIn: 'Registrarse',
    setMeetingPoint: 'Establecer Punto de Reunión',
    leadTimesheetSettings: 'Configuración de Líder y Hoja de Horas',
    createMeetingPoint: 'Crear Punto de Reunión',
    meetingLocationDesc: 'Esto creará un punto de reunión en tu ubicación actual.',
    meetingName: 'Nombre de la Reunión',
    meetingNamePlaceholder: 'ej., Reunión Matutina',
    checkInRadius: 'Radio de registro: {0}m',
    makeAdmin: 'Hacer Administrador',
    removeAdmin: 'Quitar Administrador',
    removeFromCrew: 'Quitar del Equipo',
    scanToJoin: 'Escanear para Unirse',
    orShareCode: 'O comparte este código:',
    leadName: 'Nombre del Líder/Supervisor',
    leadNamePlaceholder: 'ej., Juan Pérez',
    leadEmail: 'Email del Líder',
    leadEmailPlaceholder: 'ej., lider@empresa.com',
    companyName: 'Nombre de la Empresa',
    companyNamePlaceholder: 'ej., Servicios Energéticos ABC',
    autoSubmitTimesheet: 'Enviar hoja de horas automáticamente cada semana',
    submitOn: 'Enviar el',
    monday: 'Lunes',
    tuesday: 'Martes',
    wednesday: 'Miércoles',
    thursday: 'Jueves',
    friday: 'Viernes',
    saturday: 'Sábado',
    sunday: 'Domingo',
    settingsSaved: '¡Configuración guardada!',
    timesheetSettingsDesc: 'Configura dónde se envían automáticamente las hojas de horas semanales.',
    liveMemberLocations: 'Ubicaciones de Miembros en Vivo',
    noMembersSharedLocation: 'Ningún miembro ha compartido su ubicación recientemente.',
    submitWeeklyTimesheet: 'Enviar Hoja de Horas Semanal',
    timesheetSubmitDesc: 'Esto enviará la hoja de horas de la semana actual a tu líder ({0}).',
    noEmailConfigured: 'sin email configurado',
    week: 'Semana',
    notesOptional: 'Notas (opcional)',
    notesPlaceholder: 'Notas adicionales para tu líder...',
    noLeadEmailWarning: 'No hay email de líder configurado. Por favor configura los ajustes del líder primero.',
    submitToLead: 'Enviar al Líder',
    locationNotAvailable: 'Ubicación no disponible. Por favor habilita los servicios de ubicación.',
    roleUpdated: 'Rol actualizado a {0}',
    memberRemoved: 'Miembro eliminado',
    failedToShare: 'Error al compartir invitación',
    confirmRemove: '¿Quitar a {0}?',
    notPartOfCrews: 'Aún no eres parte de ningún equipo.',
    createOrJoinCrew: '¡Crea uno o únete con un código de invitación!',
    
    // MorningPulse
    loadingBasinPulse: 'Cargando resumen del basin...',
    unableToLoadPulse: 'No se pudo cargar el resumen del basin',
    noDataAvailable: 'Sin datos disponibles',
    tryAgain: 'Intentar de Nuevo',
    activeCount: 'activos',
    hazard: 'peligro',
    hazards: 'peligros',
    homeSafe: 'llegaron seguros',
    activeHazards: 'Peligros Activos',
    worker: 'Trabajador',
    reports: 'reportes',
    confirms: 'confirmaciones',
    homeSafeCheck: 'Llegué seguro ✓',
    madeItHome: 'Llegué a casa',
    guardian: 'guardián',
    trusted: 'confiable',
    verified: 'verificado',
    activeWorker: 'activo',
    newWorker: 'nuevo',
    
    // ErrorBoundary
    somethingWentWrong: 'Algo salió mal',
    errorDescription: 'La aplicación encontró un error inesperado. Tus favoritos guardados están seguros - intenta recargar.',
    reloadApp: 'Recargar App',
    
    // ProductionChart
    loadingProductionData: 'Cargando datos de producción...',
    productionDataUnavailable: 'Los datos de producción pueden no estar disponibles para todos los pozos',
    
    // SuggestionsDialog
    suggestFeature: 'Sugerir una Función',
    featureRequest: 'Solicitud de Función',
    bugReport: 'Reporte de Error',
    improvement: 'Mejora',
    thankYou: '¡Gracias!',
    suggestionSubmitted: '¡Tu sugerencia ha sido enviada. Apreciamos tus comentarios!',
    category: 'Categoría',
    title: 'Título',
    titlePlaceholder: 'Resumen breve de tu sugerencia',
    suggestionDescription: 'Descripción',
    suggestionDescriptionPlaceholder: 'Describe tu sugerencia en detalle. ¿Qué problema resuelve? ¿Cómo funcionaría?',
    submitSuggestion: 'Enviar Sugerencia',
    submitting: 'Enviando...',
    fillBothFields: 'Por favor completa el título y la descripción',
    newFeature: 'Nueva Función',
    navigation: 'Navegación',
    mapMarkers: 'Mapa y Marcadores',
    other: 'Otro',
    
    // DrawOverAppsPrompt
    drawOverEnhanceNav: 'Mejora tu Navegación',
    drawOverDesc: 'Habilita el permiso "Dibujar sobre otras apps" para Telegram para facilitar el regreso a ZiaWellNav mientras usas otras aplicaciones.',
    drawOverWhyEnable: '¿Por qué habilitar Dibujar sobre Apps?',
    drawOverWhyEnableDesc: 'Cuando cambias de Telegram a otra aplicación, ZiaWellNav puede mostrar superposiciones de navegación sobre tu pantalla. Esto facilita regresar a la navegación sin abrir Telegram nuevamente.',
    drawOverOpenSettings: 'Abrir Ajustes',
    drawOverOpenSettingsDesc: 'Toca el botón de abajo para abrir los ajustes de tu dispositivo. Busca el permiso "Mostrar sobre otras apps" o "Dibujar sobre otras apps".',
    drawOverEnableForTelegram: 'Habilitar para Telegram',
    drawOverEnableForTelegramDesc: 'Encuentra Telegram en la lista y habilita el permiso. Una vez habilitado, regresa aquí y toca "Listo".',
    drawOverSkip: 'Omitir por ahora',
    drawOverNext: 'Siguiente',
    drawOverDone: 'Listo',
    
    // GoHomeFAB
    goHomeSetLocation: 'Establecer Ubicación de Casa',
    goHomeUpdateLocation: 'Actualizar Ubicación de Casa',
    goHomeTooltip: 'Ir a {0} (mantener para editar)',
    goHomeTooltipNoHome: 'Establecer Ubicación de Casa',
    goHomeLocationDesc: 'Tu ubicación de casa se usa para la navegación "Ir a Casa" y para detener automáticamente el temporizador cuando llegas.',
    goHomeCurrent: 'Actual: <strong>{0}</strong>',
    goHomeLocationCaptured: '¡Ubicación capturada!',
    goHomeUseCurrentLocation: 'Usar Ubicación Actual',
    goHomeGettingLocation: 'Obteniendo Ubicación...',
    goHomeNameLabel: 'Nombre de Casa (opcional)',
    goHomeNamePlaceholder: 'ej. Mi Casa, El Rancho',
    goHomeSaveButton: 'Guardar Casa',
    goHomeNavigateQuestion: '¿Navegar a Casa?',
    goHomeNavigateTo: '¿Navegar a <strong style="color: {0}">{1}</strong>?',
    goHomeNavigateDesc: 'Esto abrirá Google Maps con direcciones a tu ubicación de casa.',
    goHomeAutoStopNote: '✓ El temporizador se detendrá automáticamente cuando llegues',
    goHomeGoButton: 'Ir a Casa',
    goHomeNavigateTitle: '🏠 Navegar a Casa',
    goHomeNavigateMessage: 'Ir a {0}',
    goHomeGoogleMaps: '🗺️ Google Maps',
    goHomeAppleMaps: '🍎 Apple Maps',
    goHomeWaze: '👻 Waze',
    goHomeToastSaved: '¡Ubicación de casa guardada! 🏠',
    goHomeToastFailed: 'Error al guardar la ubicación de casa',
    goHomeToastLocationCaptured: '¡Ubicación capturada! 📍 Agrega un nombre y guarda.',
    goHomeToastGeoNotSupported: 'La geolocalización no es compatible con tu navegador',
    goHomeToastLocationError: 'No se pudo obtener la ubicación',
    goHomeToastPermissionDenied: 'Permiso de ubicación denegado. Por favor habilita la ubicación en la configuración de tu navegador.',
    goHomeToastLocationUnavailable: 'Ubicación no disponible. Por favor intenta de nuevo.',
    goHomeToastLocationTimeout: 'Tiempo de espera de ubicación agotado. Por favor intenta de nuevo.',
    goHomeToastNavigating: '¡Navegando a casa! 🚗',
    
    // WorkTimerFAB
    workTimerStartTooltip: 'Iniciar Temporizador',
    workTimerPauseTooltip: 'Pausar (mantener para detener)',
    workTimerResumeTooltip: 'Reanudar (mantener para detener)',
    workTimerSelectCrew: 'Seleccionar Cuadrilla para Entrada de Tiempo',
    workTimerWhichCrew: '¿A qué cuadrilla se debe registrar este tiempo?',
    workTimerStopQuestion: '¿Detener Temporizador?',
    workTimerCurrentTime: 'Tiempo actual: <strong style="color: {0}">{1}</strong>',
    workTimerLoggingTo: 'Registrando a: {0}',
    workTimerKeepRunning: 'Seguir Ejecutando',
    workTimerStopButton: 'Detener Temporizador',
    workTimerYoureHome: '¡Estás en Casa!',
    workTimerArrivedAt: 'Parece que has llegado a <strong>{0}</strong>.',
    workTimerTotalTime: 'Tiempo total: <strong style="color: {0}">{1}</strong>',
    workTimerStopQuestion2: '¿Te gustaría detener el temporizador?',
    workTimerFailedStart: 'Error al iniciar',
    workTimerFailedPause: 'Error al pausar',
    workTimerFailedResume: 'Error al reanudar',
    workTimerFailedStop: 'Error al detener',
    
    // UserSupportFAB
    userSupportTooltip: 'Contactar Soporte ($1/mensaje)',
    
    // VPNWarningSnackbar
    vpnWarningMessage: '¡VPN detectado! Esto puede afectar la precisión de navegación. Considera desactivar tu VPN para un mejor rendimiento de GPS.',
    vpnDetected: 'VPN Detectado',
    vpnLearnMore: 'Saber Más',
    vpnWhyAffects: '¿Por qué el VPN afecta la navegación?',
    vpnInterferenceIntro: 'Los VPNs pueden interferir con los servicios de ubicación de varias maneras:',
    vpnIPLocation: 'La ubicación basada en IP puede mostrar un área incorrecta',
    vpnGPSBackup: 'Algunos servicios GPS usan la ubicación de red como respaldo',
    vpnMapTiles: 'La carga de mosaicos del mapa puede ser más lenta',
    vpnBestResults: 'Para mejores resultados en el campo petrolero, desactiva el VPN mientras navegas.',
    
    // OfflineSyncIndicator
    offlineTooltip: 'Fuera de línea - {0} envío{1} pendiente',
    offlineSyncing: 'Sincronizando...',
    offlinePendingTap: '{0} pendiente{1} - Toca para sincronizar',
    offlineAllSynced: 'Todo sincronizado',
    
    // ExpiredTrialBanner
    trialEnded: 'Tu prueba ha terminado. ¡Actualiza para desbloquear todas las funciones premium!',
    trialEndingSoon: '{0} — Actualiza ahora para mantener el acceso',
    upgradeNow: '✨ Actualizar Ahora',
    
    // SearchPanel
    searchButtonText: 'Buscar pozos por API, operador o ubicación...',
    searchInputPlaceholder: 'Buscar pozos...',
    searchResultsWillAppear: 'Los resultados de búsqueda aparecerán aquí...',
    
    // TelegramLogin
    telegramLoginLoading: 'Cargando...',
    telegramLoginOpenBot: 'Abrir @{0} en Telegram',
    
    // QRShareDialog
    qrShareTitle: 'Compartir ZiaWellNav',
    qrLoadingReferral: 'Cargando información de referido...',
    qrSuccessfulReferrals: '¡{0} referido{1} exitoso{1}!',
    qrScanOrShare: 'Escanea este código QR o comparte el enlace a continuación',
    qrCopyLink: 'Copiar Enlace',
    qrCopied: '¡Copiado!',
    qrShareButton: 'Compartir',
    qrEarnCredits: 'Gana Créditos Compartiendo',
    qrFreeUserSignup: 'Usuario gratuito se registra',
    qrUserConvertsPaid: 'Usuario se convierte en pagado',
    qrBusinessSignup: 'Empresa se registra',
    qrFiveReferrals: 'Hito de 5 referidos',
    qrFreeMonth: '1 MES GRATIS',
    qrShareText: '🛢️ ¡Descubre ZiaWellNav - la mejor aplicación de navegación para campos petroleros!\n\n📍 Encuentra pozos, plataformas y SWDs en toda la Cuenca Pérmica\n🗺️ Navegación GPS paso a paso a cualquier instalación\n👥 Crea y gestiona tus cuadrillas\n🔧 Encuentra servicios de campo petrolero cerca de ti\n\n¡GRATIS durante el desarrollo! Únete ahora:',
    
    // PollenAlertWidget
    pollenLoadingData: 'Cargando datos de polen...',
    pollenLabel: 'Polen',
    pollenPlantsInSeason: '{0} plantas en temporada',
    pollenInSeasonPlants: 'Plantas en Temporada:',
    pollenMorePlants: '+{0} más',
    
    // NearbyServicesWidget
    nearbyServicesTitle: 'Servicios Cercanos',
    nearbyGasStations: 'Gasolineras',
    nearbyRestaurants: 'Restaurantes',
    nearbyHotels: 'Hoteles',
    nearbyMedical: 'Médico',
    nearbyAutoRepair: 'Reparación de Autos',
    nearbyStores: 'Tiendas',
    nearbyATMs: 'Cajeros Automáticos',
    nearbyFindingPlaces: 'Buscando {0} cercanos...',
    nearbyNoPlaces: 'No se encontraron {0} en un radio de 20 millas',
    nearbyNavigateTo: '🧭 Navegar a {0}',
    nearbyChooseApp: 'Elige aplicación de navegación',
    nearbyGoogleMaps: '🗺️ Google Maps',
    nearbyAppleMaps: '🍎 Apple Maps',
    nearbyWaze: '👻 Waze',
    nearbyOpenNow: 'Abierto ahora',
    nearbyClosed: 'Cerrado',
    nearbyOpen: 'Abierto',
    nearbyGetDirections: 'Obtener Direcciones',
    
    // AutoCaptureCamera
    cameraError: 'Error de Cámara',
    cameraStarting: 'Iniciando cámara...',
    
    // AirQualityWidget
    aqiPrefix: 'ICA',
    aqiError: 'ICA: {0}',
    aqiGood: 'Buena',
    aqiModerate: 'Moderada',
    aqiUnhealthySensitive: 'Poco Saludable (Sensibles)',
    aqiUnhealthy: 'Poco Saludable',
    aqiVeryUnhealthy: 'Muy Poco Saludable',
    aqiHazardous: 'Peligrosa',
    aqiRespiratoryWarning: 'Considere protección respiratoria',
    aqiIndexLabel: 'Índice de Calidad del Aire',
    aqiPollutants: 'Contaminantes',
    aqiHealthAdvisory: 'Aviso de Salud',
    aqiUpdated: 'Actualizado: {0}',
    aqiDataUnavailable: 'Datos de calidad del aire no disponibles',
    aqiFetchFailed: 'Error al obtener calidad del aire',
    
    // ElevationWidget
    elevSafe: 'SEGURO',
    elevCaution: 'PRECAUCIÓN',
    elevWarning: 'ADVERTENCIA',
    elevDanger: 'PELIGRO',
    elevProfile: 'Perfil de Elevación',
    elevFailed: 'Error al obtener elevación',
    elevUnavailable: 'Elevación no disponible',
    elevMaxGrade: 'Pendiente Máx',
    elevTotalAscent: 'Ascenso Total',
    elevTotalDescent: 'Descenso Total',
    elevFeet: 'pies',
    elevMiles: 'mi',
    elevUphill: 'Cuesta arriba',
    elevDownhill: 'Cuesta abajo',
    elevGrade: 'Pendiente',
    elevLoading: 'Calculando elevación...',
    
    // WeatherOverlay
    weatherWindCalm: 'CALMADO',
    weatherWindModerate: 'MODERADO',
    weatherWindCaution: 'PRECAUCIÓN - RÁFAGAS',
    weatherWindWarning: 'ADVERTENCIA - VIENTO FUERTE',
    weatherWindDanger: 'PELIGRO - VIENTO MUY FUERTE',
    weatherWindHurricane: 'FUERZA DE HURACÁN',
    weatherFloodLow: 'Bajo riesgo de inundación',
    weatherFloodModerate: 'Riesgo moderado de inundación - Tenga cuidado cerca de arroyos secos',
    weatherFloodHigh: '⚠️ ALTO riesgo de inundación repentina - ¡Evite áreas bajas y arroyos!',
    weatherFloodExtreme: '⚠️ RIESGO EXTREMO DE INUNDACIÓN REPENTINA - ¡Busque terreno alto inmediatamente!',
    weatherThunderstormWarning: 'Advertencia de Tormenta',
    weatherHeavyRain: 'Alerta de Lluvia Intensa',
    weatherWind: 'Viento',
    weatherTemp: 'Temp',
    weatherFeelsLike: 'Sensación',
    weatherHumidity: 'Humedad',
    weatherVisibility: 'Visibilidad',
    weatherUVIndex: 'Índice UV',
    weatherPrecipProb: 'Precipitación',
    weatherUpdated: 'Actualizado: {0}',
    weatherUnavailable: 'Datos meteorológicos no disponibles',
    weatherFetchFailed: 'Error al obtener datos meteorológicos',
    weatherNotConfigured: 'API meteorológica no configurada',
    
    // StreetViewModal
    streetViewTitle: 'Vista Previa de Street View',
    streetViewNorth: 'Norte',
    streetViewEast: 'Este',
    streetViewSouth: 'Sur',
    streetViewWest: 'Oeste',
    streetViewNotAvailable: 'Street View no disponible en esta ubicación',
    streetViewUnavailable: 'Street View no disponible',
    streetViewLoading: 'Cargando Street View...',
    streetViewFailed: 'Error al cargar Street View',
    streetViewRotateLeft: 'Rotar izquierda',
    streetViewRotateRight: 'Rotar derecha',
    streetViewPitchUp: 'Mirar arriba',
    streetViewPitchDown: 'Mirar abajo',
    streetViewClose: 'Cerrar',
    streetViewPanorama: 'Panorama Completo',
    streetViewMetadata: 'Metadatos de Street View',
    
    // PhotoGallery
    photoNoPhotos: 'Aún no hay fotos',
    photoTapToAdd: 'Toca para agregar la primera foto',
    photoDeleteConfirm: '¿Eliminar esta foto? Esto no se puede deshacer.',
    photoDeleted: 'Foto eliminada',
    photoDeleteFailed: 'Error al eliminar foto',
    photoReportTitle: 'Reportar Foto',
    photoReportMessage: '¿Por qué estás reportando esta foto?',
    photoReportInappropriate: '🚫 Inapropiada',
    photoReportWrongLocation: '❌ Ubicación Incorrecta',
    photoReportSpam: '📧 Spam',
    photoReportSubmitted: 'Reporte enviado. ¡Gracias!',
    photoReportFailed: 'Error al enviar reporte',
    photoOf: 'Foto {0} de {1}',
    photoFullscreen: 'Ver en pantalla completa',
    photoSwipeToNavigate: 'Desliza para navegar',
    photo360: '360°',
    photoFacilityPhoto: 'Foto de instalación',
    photoDelete: 'Eliminar',
    photoReport: 'Reportar',
    
    // OnboardingDialog
    onboardingTitle: 'Datos Sin Conexión',
    onboardingSubtitle: 'Descargar para uso en campo',
    onboardingDescription: 'Accede a pozos e instalaciones incluso sin señal celular.',
    onboardingPriority: '⭐ Prioridad',
    onboardingRecommended: 'Recomendado',
    onboardingAllCounties: '📦 Todos los Condados',
    onboardingCompleteCoverage: 'Cobertura completa • 32 condados de NM',
    onboardingFastCDN: 'Modo CDN Rápido',
    onboardingDontShowAgain: 'No mostrar de nuevo',
    onboardingDownloading: 'Descargando...',
    onboardingSkipForNow: 'Omitir por ahora',
    onboardingContinueUsing: 'Continuar Usando la App',
    onboardingBackgroundNote: 'Puedes cerrar esto y seguir usando la app. Las descargas se ejecutan en segundo plano.',
    onboardingRemaining: '{0} restante',
    
    // LocationPermissionDialog
    locationPermissionTitle: 'Acceso de Ubicación',
    locationPermissionDescription: 'ZiaWellNav quiere acceder a tu ubicación',
    locationPermissionGrant: 'Permitir',
    locationPermissionLater: 'Ahora No',
    locationPermissionNever: 'Nunca Permitir',
    locationPermissionIndefinitely: 'Permitir Indefinidamente',
    locationPermissionIndefinitelyDesc: 'Permitir acceso de ubicación siempre sin preguntar de nuevo',
    locationPermissionSession: 'Permitir Mientras Uso la App',
    locationPermissionSessionDesc: 'Permitir hasta cerrar la app o por 24 horas',
    locationPermissionOnce: 'Permitir Una Vez',
    locationPermissionOnceDesc: 'Permitir solo esta vez, preguntar de nuevo la próxima vez',
    
    // SubscriptionPanel
    subscriptionTitle: 'Actualizar a Premium',
    subscriptionMonthly: 'Mensual',
    subscriptionYearly: 'Anual',
    subscriptionFreeTrial: 'Prueba Gratuita',
    subscriptionSubscribe: 'Suscribirse Ahora',
    subscriptionCancel: 'Cancelar en Cualquier Momento',
    subscriptionFeature1: 'Búsquedas ilimitadas',
    subscriptionFeature2: 'Mapas sin conexión',
    subscriptionFeature3: 'Soporte premium',
    
    // WellDetailsModal
    wellDetailsTitle: 'Detalles del Pozo',
    wellDetailsAPI: 'Número API',
    wellDetailsOperator: 'Operador',
    wellDetailsStatus: 'Estado',
    wellDetailsType: 'Tipo',
    wellDetailsLocation: 'Ubicación',
    wellDetailsElevation: 'Elevación',
    wellDetailsDepth: 'Profundidad',
    wellDetailsProduction: 'Producción',
    wellDetailsClose: 'Cerrar',
    
    // AddFacilityForm
    addFacilityTitle: 'Agregar Instalación',
    addFacilityName: 'Nombre de la Instalación',
    addFacilityType: 'Tipo de Instalación',
    addFacilityLocation: 'Ubicación',
    addFacilityNotes: 'Notas',
    addFacilitySubmit: 'Enviar',
    addFacilityCancel: 'Cancelar',
    
    // HomeSpeedDial
    homeAndLocation: 'Inicio y Ubicación',
    homeResetMapView: 'Restablecer Vista del Mapa',
    homeSetLocation: 'Establecer Ubicación de Inicio',
    homeUpdateHome: 'Actualizar Inicio',
    homeNavigateHome: 'Navegar a Inicio',
    
    // FriendsPanel
    friendsTitle: 'Amigos',
    friendsShareInvite: 'Compartir Enlace de Invitación',
    friendsShareLocation: 'Compartir Mi Ubicación',
    friendsShareLocationDesc: 'Permite que tus amigos vean tu ubicación en tiempo real en el mapa',
    friendsTabFriends: 'Amigos',
    friendsTabRequests: 'Solicitudes',
    friendsAddByUsername: 'Agregar Amigo por Nombre de Usuario',
    friendsNoFriends: 'Aún no hay amigos. ¡Agrega amigos para compartir ubicaciones!',
    friendsNoPendingRequests: 'No hay solicitudes de amistad pendientes',
    friendsLocationAvailable: 'Ubicación disponible',
    friendsWaitingLocation: 'Esperando ubicación...',
    friendsLocationNotShared: 'Ubicación no compartida',
    friendsStopSharing: 'Dejar de compartir ubicación',
    friendsStartSharing: 'Compartir tu ubicación',
    friendsNavigateTo: 'Navegar hacia amigo',
    friendsRemoveFriend: 'Eliminar amigo',
    friendsAddFriend: 'Agregar Amigo',
    friendsEnterUsername: 'Ingresa el nombre de usuario de Telegram de tu amigo',
    friendsSendRequest: 'Enviar Solicitud',
    friendsWantsToBeFriend: 'Quiere ser tu amigo',
  }
} as const;

export type TranslationKey = keyof typeof translations.en;
export type Language = 'en' | 'es';

// Hook for using translations
export function useTranslation() {
  const language = useAppStore((state) => state.language);
  
  const t = (key: TranslationKey, ...args: (string | number)[]): string => {
    let text: string = translations[language][key] || translations.en[key] || key;
    
    // Replace placeholders like {0}, {1}, etc.
    args.forEach((arg, index) => {
      text = text.replace(`{${index}}`, String(arg));
    });
    
    return text;
  };
  
  return { t, language };
}

// Non-hook version for use outside of components
export function getTranslation(language: Language, key: TranslationKey, ...args: (string | number)[]): string {
  let text: string = translations[language][key] || translations.en[key] || key;
  
  args.forEach((arg, index) => {
    text = text.replace(`{${index}}`, String(arg));
  });
  
  return text;
}
